module.exports = __webpack_public_path__ + "assets/img/guarantees.dc0043d6.png";